import React, { useEffect, useState, useContext } from 'react'
import { styled } from '@mui/material/styles'
import Layout from '@/product/components/templates/Layout'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import { Button } from '@mui/material'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { useFormik } from 'formik'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import PropTypes from 'prop-types'
import Tab from '@mui/material/Tab'
import AuctionContext from '@/product/context/auction/auctionContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'
import ImageEdit from '@/product/components/organisms/ImageEdit/index'
import FieldHeader from './FieldHeader'

const PREFIX = 'ERP'

const classes = {
    root: `${PREFIX}-root`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <div>{children}</div>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const Inventory = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const auctionContext = useContext(AuctionContext)
    const { erp_tablefields, project_dynamicfields, propertyColumnReOrder } =
        dynamicContext
    const { all_auctions, getAllAuctions, responseStatus, clearResponse } =
        auctionContext
    const { alldata_all_dropdown } = useContext(CustomCommonContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [dynamicFieldValues, setDynamicFieldValues] = useState([])
    const [mapArrayData, setMapArrayData] = useState([])
    const history = useHistory()
    const [custom, setCustom] = useState({})

    let invId = props.match.params.id ? props.match.params.id : 0

    const [imageManage, setImageManage] = useState({
        popup: false,
        id: 0,
    })

    const toggleImageEditFullScreenPopup = (popup, id) => {
        if (popup) {
            setImageManage({ popup, id })
        } else {
            setImageManage({ popup, id: 0 })
        }
    }

    const [aucId, setAucId] = useState('')
    const [lotStatus, setLotStatus] = useState('draft')
    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `listing/edit/${id}`)
        } else if (type === 'imageview') {
            toggleImageEditFullScreenPopup(true, id)
        }
    }

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup && status == 'edit') {
            handleRedirectInternal(history, `listing/edit/${id}`)
        }
    }

    useEffect(() => {
        setCustom({
            market_status: {
                value: aucId !== '' || lotStatus ? [] : ['open', 'draft'],
                type: 'array',
                field: 'p.market_status',
            },
            action: {
                value: aucId !== '' ? '' : lotStatus || '',
                type: 'in',
                field: 'p.market_status',
            },
            auctionid: {
                value: aucId !== '' ? aucId : '0',
                type: 'in',
                field: 'p.auctionid',
            },
        })
    }, [lotStatus, aucId])

    useEffect(() => {
        if (erp_tablefields && erp_tablefields.length) {
            console.log(erp_tablefields, 'project')
            let dynamicValueAssign = {}
            dynamicValueAssign.data = erp_tablefields
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })

            dynamicValueAssign.data.push({
                label: 'Category',
                placeholder: 'Select Category',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'select',
                filter_type: 'in',
                field: 'category',
                name: 'category',
                filter: true,
                table_search: 1,
                view_page: '1',
                active: 1,
                is_default: 0,
                options: alldata_all_dropdown
                    .filter((maincat) => maincat.variable === 'category')
                    .map((maincat) => {
                        let categoryChanged = {}
                        categoryChanged.show = maincat.description
                        categoryChanged.value = maincat.id
                        return categoryChanged
                    }),
            })
            console.log(dynamicValueAssign.data, 'project')
            setSearchInfo(dynamicValueAssign)
        }
    }, [lotStatus, erp_tablefields])

    useEffect(() => {
        if (erp_tablefields && erp_tablefields.length) {
            console.log(erp_tablefields, 'okayyy')

            let dynamicValueAssign = [...erp_tablefields]
            dynamicValueAssign.map((data) => {
                if (data.field === 'title') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }

                console.log('data CHECK', data)
                if (data.field === 'avatar') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'imageview'
                    data.type = 'imagewithurl'
                }

                if (data.type === 'singleSelect' || 'multiselect') {
                    console.log(data.name, 'select')
                    if (data.options) {
                        data.valueOptions = data.options
                    } else {
                        data.valueOptions = alldata_all_dropdown
                            .filter(
                                (value) =>
                                    value.variable === data.field &&
                                    value.level === 0
                            )
                            .map((item) => {
                                let valueChanged = {}
                                valueChanged.label = item.description
                                valueChanged.value = data.diff_value
                                    ? item.value
                                    : item.id
                                return valueChanged
                            })
                    }
                }
            })

            if (lotStatus === 'draft') {
                dynamicValueAssign.push({
                    active: 1,
                    field: 'requiredFieldsStatus',
                    folder: null,
                    id: 21,
                    is_deletable: 0,
                    label: 'Missing fields',
                    show_order: 500,
                    sort: 0,
                    sort_field: 'p.wprice',
                    table_search: 0,
                    type: 'tooltip',
                    tooltipTitle: 'requiredFields',
                    tooltipType: 'field',
                    view_page: '1',
                })
            }

            dynamicValueAssign.push({
                active: 1,
                field: 'uploadimages',
                folder: 'product',
                id: 23,
                is_deletable: 0,
                label: 'Images',
                show_order: 500,
                sort: 0,
                table_search: 0,
                type: 'multiimagewithurl',
                tooltipTitle: 'requiredFields',
                tooltipType: 'field',
                view_page: '1',
            })

            if (lotStatus != 'draft') {
                dynamicValueAssign.push({
                    field: 'bidscount',
                    type: '',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Bid Count',
                    tableShow: 1,
                    table_search: 1,
                })
            }

            console.log('editable: true, 33333', dynamicValueAssign)
            setTableValue(dynamicValueAssign)
        }
    }, [erp_tablefields, lotStatus])

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let dynamicValueAssign = project_dynamicfields
            console.log(project_dynamicfields, 'dynamicc')
            setMapArrayData(dynamicValueAssign)
            setDynamicFieldValues(dynamicValueAssign)
        }
    }, [project_dynamicfields])

    useEffect(() => {
        if (invId) {
            if (invId !== 0) {
                console.log(invId, 'prop')
                setAucId(parseInt(invId, 10))
            }
        }
    }, [invId, erp_tablefields])

    useEffect(() => {
        if (tableValue.length) {
            tableValue.map((data, index) => {
                if (data.field === 'id') {
                    data.disabled = true
                }
            })
        }
    }, [tableValue])

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            order: '',
            having: {
                future_active: {
                    value: 0,
                    type: 'in',
                    field: 'future_active',
                },
            },
            filters: {
                action: {
                    value: 'open',
                    type: 'in',
                    field: 'ac.market_status',
                },
                title: {
                    type: 'in',
                    value: '',
                    field: 'ac.title',
                },
                date_added: {
                    type: 'dategreaterequal',
                    value: '',
                    field: 'ac.date_added',
                },
                date_closed: {
                    type: 'datesmallerequal',
                    value: '',
                    field: 'ac.date_closed',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            getAllAuctions(values)
        },
    })
    const [value, setValue] = useState(0)
    const handleChange = (event, newValue) => {
        let dynamicValueAssign = [...erp_tablefields]
        if (newValue === 0) {
            setValue(newValue)
            setTableValue(dynamicValueAssign)
        } else if (newValue === 1) {
            setValue(newValue)
            const filteredData = []
            dynamicValueAssign.map((data) => {
                if (
                    data.name == 'id' ||
                    data.name == 'title' ||
                    data.label == 'Picture' ||
                    data.name === 'uploadimages'
                ) {
                    filteredData.push(data)
                }
            })
            setTableValue(filteredData)
        } else if (newValue === 2) {
            const filteredData = []
            dynamicValueAssign.map((data) => {
                if (
                    data.name == 'lot_id' ||
                    data.name == 'title' ||
                    data.label == 'Picture' ||
                    data.name === 'uploadimages'
                ) {
                    filteredData.push(data)
                }
            })
            filteredData.push(
                {
                    field: 'status',
                    type: '',
                    firstChild: true,
                    sort: false,
                    disablePadding: false,
                    label: 'Status',
                },
                {
                    field: 'vendor_name',
                    type: '',
                    firstChild: true,
                    sort: false,
                    disablePadding: false,
                    label: 'Vendor Name',
                },
                {
                    field: 'vendor_code',
                    type: '',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Vendor Code',
                    filterable: true,
                    filterField: 'it.vendor_code',
                },
                {
                    field: 'vendor_warehouse_location',
                    type: '',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Vendor Warehouse',
                    filterable: true,
                    filterField: 'it.vendor_warehouse_location',
                },
                {
                    field: 'po_number',
                    type: '',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'PO Number',
                    filterable: true,
                    filterField: 'it.po_number',
                },
                {
                    field: 'cost_per_unit',
                    type: 'price',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Cost per unit',
                    filterable: true,
                    filterField: 'it.cost_per_unit',
                },
                {
                    field: 'carrier',
                    type: 'text',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Carrier',
                    filterable: true,
                    filterField: 'it.carrier',
                },
                {
                    field: 'carrier_tracking',
                    type: 'text',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Carrier Tracking',
                    filterable: true,
                    filterField: 'it.carrier_tracking',
                },
                {
                    field: 'ship_to_location',
                    type: 'text',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Ship To Location',
                    filterable: true,
                    filterField: 'it.ship_to_location',
                },
                {
                    field: 'truck_number',
                    type: 'text',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Truck Number',
                    filterable: true,
                    filterField: 'it.truck_number',
                },
                {
                    field: 'pallet_number',
                    type: '',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Pallet Number',
                    filterable: true,
                    filterField: 'it.pallet_number',
                },
                {
                    field: 'retailer_load',
                    type: 'text',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Retailer Load',
                    filterable: true,
                    filterField: 'it.retailer_load',
                }
            )

            setTableValue(filteredData)
            setValue(newValue)
        }
    }

    useEffect(() => {
        getAllAuctions(formik.values)
    }, [])

    const additionalFilterCallBack = (data) => {
        setLotStatus(data.lots)
        setAucId(data.auctions)
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }
    return (
        <StyledLayout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            <div className="dashboard listing maillisting erpMisc">
                <FieldHeader />
                <div className="erpTabs">
                    <AppBar position="static">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="ERP Tabs"
                        >
                            <Tab label="Default" {...a11yProps(0)} />
                            <Tab label="Images" {...a11yProps(1)} />
                            <Tab label="Vendor View" {...a11yProps(2)} />
                        </Tabs>
                    </AppBar>
                </div>

                <TabPanel value={value} index={0}>
                    <ListingTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={[
                            'open',
                            'auction_assign',
                            'all_removed',
                            'all_auction_assign',
                        ]}
                        listActionString={['bidcount']}
                        action={lotStatus}
                        dynamicFieldValues={dynamicFieldValues}
                        enableEditTableCell={
                            global?.enableEditTableCell
                                ? global?.enableEditTableCell
                                : false
                        }
                        enableColumnEdit={
                            global?.enableColumnEdit
                                ? global?.enableColumnEdit
                                : false
                        }
                        auctionList={all_auctions}
                        additionalFilter={
                            global?.additionalFilter
                                ? global?.additionalFilter
                                : false
                        }
                        additionalFilterCallBack={additionalFilterCallBack}
                        additionalFilterCustom={{
                            auctions: invId ? invId.toString() : '',
                        }}
                        mapArrayData={mapArrayData}
                        propertyColumnReOrder={propertyColumnReOrder}
                        reorderId={'show_order'}
                        showSelectValues={
                            global?.showSelectValues
                                ? global?.showSelectValues
                                : false
                        }
                        reorder={aucId !== '' && aucId !== '0' ? true : false}
                        deleteIcon={
                            global?.deleteIcon ? global?.deleteIcon : false
                        }
                        order={'asc'}
                        auctionAssign_action={['open', 'draft']}
                        orderby={'it.show_order'}
                        barcode={global?.barcode ? global?.barcode : false}
                        qrcode={global?.qrcode ? global?.qrcode : false}
                        advFilters={
                            global?.advFilters ? global?.advFilters : false
                        }
                        feature={true}
                        columnStorageVariable={'table_erp_inventory'}
                    />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <ListingTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={[
                            'open',
                            'auction_assign',
                            'all_removed',
                            'all_auction_assign',
                        ]}
                        listActionString={['bidcount']}
                        action={lotStatus}
                        dynamicFieldValues={dynamicFieldValues}
                        enableEditTableCell={
                            global?.enableEditTableCell
                                ? global?.enableEditTableCell
                                : false
                        }
                        enableColumnEdit={
                            global?.enableColumnEdit
                                ? global?.enableColumnEdit
                                : false
                        }
                        auctionList={all_auctions}
                        additionalFilter={
                            global?.additionalFilter
                                ? global?.additionalFilter
                                : false
                        }
                        additionalFilterCallBack={additionalFilterCallBack}
                        additionalFilterCustom={{
                            auctions: invId ? invId.toString() : '',
                        }}
                        mapArrayData={mapArrayData}
                        propertyColumnReOrder={propertyColumnReOrder}
                        reorderId={'show_order'}
                        showSelectValues={
                            global?.showSelectValues
                                ? global?.showSelectValues
                                : false
                        }
                        reorder={aucId !== '' && aucId !== '0' ? true : false}
                        deleteIcon={
                            global?.deleteIcon ? global?.deleteIcon : false
                        }
                        order={'asc'}
                        auctionAssign_action={['open', 'draft']}
                        orderby={'it.show_order'}
                        barcode={global?.barcode ? global?.barcode : false}
                        qrcode={global?.qrcode ? global?.qrcode : false}
                        advFilters={
                            global?.advFilters ? global?.advFilters : false
                        }
                        feature={true}
                        imageIcon={true}
                        columnStorageVariable={'table_erp_inventory'}
                    />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <ListingTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={[
                            'open',
                            'auction_assign',
                            'all_removed',
                            'all_auction_assign',
                        ]}
                        listActionString={['bidcount']}
                        action={lotStatus}
                        dynamicFieldValues={dynamicFieldValues}
                        enableEditTableCell={
                            global?.enableEditTableCell
                                ? global?.enableEditTableCell
                                : false
                        }
                        enableColumnEdit={
                            global?.enableColumnEdit
                                ? global?.enableColumnEdit
                                : false
                        }
                        auctionList={all_auctions}
                        additionalFilter={
                            global?.additionalFilter
                                ? global?.additionalFilter
                                : false
                        }
                        additionalFilterCallBack={additionalFilterCallBack}
                        additionalFilterCustom={{
                            auctions: invId ? invId.toString() : '',
                        }}
                        mapArrayData={mapArrayData}
                        propertyColumnReOrder={propertyColumnReOrder}
                        reorderId={'show_order'}
                        showSelectValues={
                            global?.showSelectValues
                                ? global?.showSelectValues
                                : false
                        }
                        reorder={aucId !== '' && aucId !== '0' ? true : false}
                        deleteIcon={
                            global?.deleteIcon ? global?.deleteIcon : false
                        }
                        order={'asc'}
                        auctionAssign_action={['open', 'draft']}
                        orderby={'it.show_order'}
                        barcode={global?.barcode ? global?.barcode : false}
                        qrcode={global?.qrcode ? global?.qrcode : false}
                        advFilters={
                            global?.advFilters ? global?.advFilters : false
                        }
                        feature={true}
                        columnStorageVariable={'table_erp_inventory'}
                    />
                </TabPanel>
                <ImageEdit
                    data={imageManage}
                    function={toggleImageEditFullScreenPopup}
                />
            </div>
        </StyledLayout>
    )
}

export default Inventory
